
import { useState } from "react";
import { ServiceForm } from "@/components/professional/ServiceForm";
import { ProductForm } from "@/components/professional/ProductForm";

interface ServicesDialogsProps {
  isServiceFormOpen: boolean;
  setIsServiceFormOpen: (open: boolean) => void;
  isProductFormOpen: boolean;
  setIsProductFormOpen: (open: boolean) => void;
}

export const ServicesDialogs = ({ 
  isServiceFormOpen, 
  setIsServiceFormOpen,
  isProductFormOpen,
  setIsProductFormOpen
}: ServicesDialogsProps) => {
  return (
    <>
      <ServiceForm 
        open={isServiceFormOpen}
        onOpenChange={setIsServiceFormOpen}
      />

      <ProductForm 
        open={isProductFormOpen}
        onOpenChange={setIsProductFormOpen}
      />
    </>
  );
};
